import React, { FC } from "react";
import { useIntl } from "react-intl";
import { InfoCard } from "@natera/patient";
import { Button } from "@natera/form";
import CardParams from "./secondaryActionCardParams";
import { SecondaryCard } from "@app/provider/testData/types";
import "./secondaryActionCard.scss";

interface SecondaryActionCardProps {
  card: SecondaryCard;
}

const SecondaryActionCard: FC<SecondaryActionCardProps> = ({ card }) => {
  const intl = useIntl();

  const params = CardParams({ card });

  const cardParam = params[card.type];

  if (!cardParam) {
    return null;
  }

  return (
    <div className="sec-action-card-wrapper">
      <InfoCard
        icon={cardParam.icon || ""}
        contentAside={cardParam.contentAside}
        vertical={!!cardParam.contentAside}
      >
        <div className="sec-action-card">
          <h4 data-testid="card-title" className="sec-action-card__title">
            {card.title}
          </h4>
          <div
            data-testid="card-description"
            className="sec-action-card__description"
          >
            {card.description}
          </div>
          <div className="sec-action-card__btn">
            <Button
              outlined
              onClick={cardParam.btn.action}
              data-automation_id="learn_more_button"
            >
              {intl.formatMessage(cardParam.btn.title)}
            </Button>
          </div>
        </div>
      </InfoCard>
    </div>
  );
};

export default SecondaryActionCard;
